// =============================================================================
// PRIVACY PAGE COMPONENT
// =============================================================================

import React from 'react';
import { Navbar, Footer } from '@/components/Layout';
import { ContentRenderer } from '@/components/ContentRenderer';
import { SEOHead } from '@/components/SEO';
import { privacyPageComponents } from '@/data/legalPageContent';
import { navItems, footerLinks, socialLinks } from '@/data/homeContent';
import { seoData } from '@/data/seoData';

export const PrivacyPage: React.FC = () => {
  const seo = seoData.privacy;
  
  return (
    <div className="privacy-page">
      <SEOHead
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        noIndex={seo.noIndex}
      />
      
      <Navbar 
        brand="Awani"
        navItems={navItems}
        showThemeSwitcher={true}
      />
      
      <main className="main-content">
        <ContentRenderer components={privacyPageComponents} />
      </main>
      
      <Footer
        brand="Awani"
        description="Privacy policy for Awani. Learn how we collect, use, and protect your personal information when you shop with us or place a custom order."
        links={footerLinks}
        socialLinks={socialLinks}
      />
    </div>
  );
};
